/**
 * @file Drag source absences base component
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { DragSourceBaseComponent } from '../drag-source-base/drag-source-base.component';
/** Drag source absences base component. */
var DragSourceAbsencesBaseComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DragSourceAbsencesBaseComponent, _super);
    function DragSourceAbsencesBaseComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets the label for a sum factor.
     * @param {number} factor A specific sum factor
     * @returns {string} The Label
     */
    DragSourceAbsencesBaseComponent.prototype.getLabelSumFactor = function (factor) {
        // Gebruik niet de algemenen labels als je hier een meer context specifiek label wil gebruiken.
        switch (factor) {
            case 1:
                return 'APP.MISC.PLANITEM.SUMFACTOR_ADD';
            case 0:
                return 'APP.MISC.PLANITEM.SUMFACTOR_NONE';
            case -1:
                return 'APP.MISC.PLANITEM.SUMFACTOR_SUBTRACT';
            default:
                return '';
        }
    };
    /**
     * Initiate the executors for given source
     */
    DragSourceAbsencesBaseComponent.prototype.initiateExecutors = function () {
        // Get the executors
        this.availableExecutors = this.executorsService.getExecutors('drop', 'Absence');
        // Default pick the first available drop method
        this.selectedExecutorName = (this.availableExecutors.length > 0) ? this.availableExecutors[0].name : undefined;
    };
    return DragSourceAbsencesBaseComponent;
}(DragSourceBaseComponent));
export { DragSourceAbsencesBaseComponent };
